import { SxProps, Theme, Button, ButtonProps } from '@mui/material';
import { CSSProperties } from '@mui/material/styles/createMixins';
import { FunctionComponent } from 'react';
import { ColorPalette } from 'shared/consts/colorPalette';
import { Icon } from 'shared/ui/Icon';

interface Props extends ButtonProps {
	iconId: string;
	active?: boolean;
	onClick?: (event: React.MouseEvent<HTMLElement>) => void;
	sxWrapper?: SxProps<Theme>;
	sxIcon?: CSSProperties;
}

export const IconButton: FunctionComponent<Props> = ({
	sxWrapper,
	sxIcon,
	iconId,
	active,
	onClick,
	...props
}) => {
	return (
		<Button
			disableRipple
			sx={{
				minWidth: '46px',
				maxWidth: '46px',
				height: '46px',
				display: 'flex',
				justifyContent: 'center',
				alignItems: 'center',
				backgroundColor: active ? ColorPalette.royalBlue : ColorPalette.white,
				color: active ? ColorPalette.white : ColorPalette.royalBlue,
				borderRadius: '12px',
				cursor: 'pointer',
				transition: 'all .3s',
				position: 'relative',
				padding: 0,
				...sxWrapper,
			}}
			onClick={onClick}
			{...props}
		>
			<Icon id={iconId} style={{ width: '24px', height: '24px', color: 'inherit', ...sxIcon }} />
		</Button>
	);
};
